export default {
  day: "",
  startsAt: "",
  endsAt: "",
  distance: 0,
  standsCount: 0,
  eventId: "",
  autoAssign: false
}
